import { Helmet } from 'react-helmet'

import { OnboardingBannerSlot } from '@/components/OnboardingBannerSlot'
import { SkeletonRows } from '@/components/ui/skeleton'
import { useCurrentUser } from '../../../../models/user'
import { BusinessTab } from '../AdminSettings/BusinessTab'

export function FleetDetails() {
  const { user, isLoading } = useCurrentUser({ enabled: true })

  function renderContent() {
    if (isLoading || !user) {
      return <SkeletonRows />
    }

    return <BusinessTab business={user.currentOrg.business} />
  }

  return (
    <>
      <Helmet>
        <title>Business info</title>
      </Helmet>
      <h1 className="text-ink mb-4 text-2xl font-bold tracking-[-0.01em]">Business info</h1>
      <div className="flex flex-col gap-5">
        <OnboardingBannerSlot />
        {renderContent()}
      </div>
    </>
  )
}
